import React from "react";
import styled from "styled-components";

function FlexEnd(props) {
    const FlexEnd = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  `;
  return (
    <FlexEnd>
        {props.children}
    </FlexEnd>
  );
}

export default FlexEnd;
